// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28VUk","question":"styles_question__3mTvD","description":"styles_description__3pfvZ"};